import React, { useState } from 'react';
import axios from 'axios';
import { ArrowUpRight, LockKeyhole, ArrowLeft, ShieldCheck } from 'lucide-react';

export function PortalBrand() {
  return <div className="ip-brand"><span className="ip-brand-mark">P<span>F</span>S</span><div>Power Funding<span>INVESTOR PORTAL</span></div></div>;
}

export default function PortalSignIn({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [reset, setReset] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const submit = async event => {
    event.preventDefault(); setBusy(true); setError(''); setMessage('');
    try {
      if (reset) {
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, { email });
        setMessage('If your email is registered, you’ll receive password reset instructions.');
      } else await onLogin(email, password);
    } catch (e) {
      setError(reset ? 'We couldn’t send your request. Please try again.' : 'We couldn’t sign you in. Check your email and password and try again.');
    } finally { setBusy(false); }
  };
  return <div className="ip-login">
    <aside className="ip-login-story"><PortalBrand /><div><p className="ip-eyebrow">YOUR INVESTMENT. IN VIEW.</p><h1>A clear view of<br />every deal.</h1><p>Follow your collections, keep track of distributions, and access your statements in one place.</p><div className="ip-login-rule" /><span>Built for your partnership with PFS.</span></div><small>Power Funding Solutions · Investor services</small></aside>
    <main className="ip-login-main"><div className="ip-login-form"><LockKeyhole size={26} /><p className="ip-eyebrow">INVESTOR ACCESS</p><h2>{reset ? 'Reset your password' : 'Welcome back.'}</h2><p>{reset ? 'Enter the email associated with your investor account.' : 'Sign in to your Power Funding account.'}</p>
      <form onSubmit={submit}>
        <label>Email address<input type="email" autoComplete="username" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@company.com" /></label>
        {!reset && <label>Password<input type="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} required /></label>}
        {error && <p className="ip-error" role="alert">{error}</p>}{message && <p className="ip-success" role="status">{message}</p>}
        <button className="ip-primary" type="submit" disabled={busy}>{busy ? 'Please wait…' : reset ? 'Send reset instructions' : 'Sign in to your account'}<ArrowUpRight size={18} /></button>
      </form>
      <button className="ip-text-button" onClick={() => { setReset(!reset); setError(''); setMessage(''); }}>{reset ? <><ArrowLeft size={14} /> Back to sign in</> : 'Forgot your password?'}</button>
      <div className="ip-login-help"><ShieldCheck size={19} /><p>Use your existing PFS login. Need account access? Contact your PFS representative.</p></div>
    </div></main>
  </div>;
}
